export const useDevice = () => {
  const deviceType = computed(() => {
    const userAgent = navigator.userAgent.toLowerCase()
    return /iphone|ipod|ipad|android|blackberry|windows phone/i.test(userAgent) ? 'MOBILE' : 'PC'
  })

  return { deviceType }
}
